import React from 'react';
import { Select, MenuItem, CircularProgress } from '@material-ui/core';
import { useLanguage } from "../../hooks/useLanguage";
import { LanguagesOptions } from "../../enums/LanguagesOptions";

export const LanguageInput = (props) => {
    const { selectedLanguage, changeLanguage, isLoading } = useLanguage();

    const handleChange = (e) => {
        const lang = e.target.value;

        // Mark this as a user selection explicitly
        localStorage.setItem("userSelectedLang", lang);
        localStorage.setItem("userHasManuallySelected", "true");
        localStorage.setItem("appLang", lang);

        changeLanguage(lang);
    };

    const LTR = selectedLanguage === 'ar' || selectedLanguage === 'ur' || selectedLanguage === 'fa';

    return (
        <React.Fragment>
            <Select
                value={selectedLanguage}
                variant={'outlined'}
                size={'small'}
                defaultValue={'en'}
                onChange={handleChange}
                className={'language-input'}
                disabled={isLoading}
            >
                {LanguagesOptions.map((language) => (
                    <MenuItem style={{
                        display: 'flex',
                        alignItems: 'center'
                    }} key={language.code} value={language.code}>
                        <img
                            src={language.flag}
                            alt={`${language.nativeName} flag`}
                            className="flag-icon"
                            style={{
                                width: 24,
                                height: 16,
                                marginRight: LTR ? 0 : 8,
                                marginLeft: LTR ? 8 : 0,
                               /// marginBottom: 4,
                                objectFit: 'cover',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.2)'
                            }}
                        />
                        {language.nativeName}
                    </MenuItem>
                ))}
            </Select>
            {/*{isLoading && (*/}
            {/*    <CircularProgress*/}
            {/*        size={20}*/}
            {/*        style={{ marginLeft: 8 }}*/}
            {/*    />*/}
            {/*)}*/}
        </React.Fragment>
    );
};

export default LanguageInput;